import { createSelector } from 'reselect';
import { type ReduxStateShared } from '~shared/types';

export const getInsurances = (state: ReduxStateShared) => state.insurances.insurances || [];

export const getLastRequestAttemptedAt = (state: ReduxStateShared) => state.insurances.lastRequestAttemptedAt;

export const getLastRequestSucceededAt = (state: ReduxStateShared) => state.insurances.lastRequestSucceededAt;

export const getRequestAttemptCount = (state: ReduxStateShared) => state.insurances.requestAttemptCount;

export const getSelectedInsuranceID = (state: ReduxStateShared) => state.insurances.selectedInsuranceID;

export const hasGovernmentInsurance = createSelector([getInsurances], (insurances) => {
  return insurances.filter(({ is_government_insurance }) => is_government_insurance).length > 0;
});
